module.exports = __webpack_public_path__ + "img/Number=47.a7599e06.png";